import React from 'react';
import './StudioSection.css';

const StudioSection = () => {
  const pillars = ['Precision', 'Discipline', 'Intent'];

  return (
    <section id="studio" className="studio-section">
      <div className="studio-container">
        <div className="studio-header">
          <h2 className="studio-title">THE LODGE — STUDIO</h2>
          <div className="divider-left"></div>
          <p className="studio-description">
            A private-feeling studio built on modern craft and quiet confidence.
          </p>
        </div>

        <div className="pillars-grid">
          {pillars.map((pillar, index) => (
            <div key={index} className="pillar-item">
              <span className="pillar-number">0{index + 1}</span>
              <h3 className="pillar-name">{pillar}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StudioSection;